export const calculatetShippingTotal = ({ customLineItems = [] }) =>
  customLineItems
    .filter(
      (shippingItem) => !!shippingItem.custom?.fields?.netsuite_shipping_name,
    )
    .reduce(
      (total, customLineItem) => total + customLineItem.totalPrice.centAmount,
      0,
    );

export const convertCentsToDollars = (value) => {
  const dollar = `${value}`.replace(/[^\d.-]/g, '');
  const floatDollar = parseFloat(dollar);
  return (floatDollar ? floatDollar / 100.0 : 0).toFixed(2);
};

export const convertMonthsToYears = (value) =>
  value / 12;

export const formatDate = (inputDate) => {
  let date;
  let month;

  date = inputDate.getDate();
  month = inputDate.getMonth() + 1;
  const year = inputDate.getFullYear();

  date = date.toString().padStart(2, '0');

  month = month.toString().padStart(2, '0');

  return `${month}/${date}/${year}`;
};

export const formatUSPhoneNumber = (number = '') => {
  // +11234567890, 123-456-7890, 1234567890 => (123) 456-7890
  const trimmedNumber = number.replace(/[^\d]/g, '');
  const numberWithoutCountryCode =
    trimmedNumber.length === 11 ? trimmedNumber.slice(1) : trimmedNumber;
  return numberWithoutCountryCode.replace(/\D+/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
};

// two addresses are considered as the same if postal code and street is equal
export const matchTwoAddresses = (address1, address2) =>
  address1.street.trim().toLowerCase() === address2.street.trim().toLowerCase() &&
  address1.postalCode === address2.postalCode;

export const isValidEmail = (email) => /^[\w\-.]+@(?:[\w-]{1,}\.)+[a-zA-Z]{2,}$/.test(email);

export const extractNumbers = (value) => {
  const numbers = value?.match(/\d+/g);
  return numbers ? numbers.join('') : '';
};

export const getPhoneDigitsOnly = (number) =>
  (number?.startsWith('+1') ? number.replace('+1', '') : number)?.replace(/\D/g, '');

// eslint-disable-next-line default-param-last
export const getAttributeValue = (attributes = [], name) =>
  attributes.find((a) => a.name === name)?.value ?? '';

export const calculateLineItemTotalDiscount = ({ quantity, custom }) =>
  JSON.parse(custom.fields.discounts_json).reduce(
    (totalLine, discount) => totalLine + discount.cent_amount,
    0,
  ) * quantity;

export const calculateOrderTotalDiscount = (lineItems) =>
  lineItems.reduce(
    (acu, curr) => {
      const lineItemTotalDiscount =
      calculateLineItemTotalDiscount({ quantity: curr.quantity, custom: curr.custom });
      return acu + lineItemTotalDiscount;
    },
    0);
